import { useState } from "react";
import "./MobileHeader.css";
import projectLogo from "../../assets/project.svg";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Drawer, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface MobileHeaderProps {
  onMenuClick?: () => void;
}

const MobileHeader = ({ onMenuClick }: MobileHeaderProps) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
    setSearchQuery("");
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/searchcv?searchQuery=${encodeURIComponent(searchQuery)}`);
      handleSearchClose();
    }
  };

  return (
    <>
      <header className="mobile-header">
        <div className="mobile-header-container">
          <div className="mobile-header-logo">
            <img src={projectLogo} alt="TASC Logo" />
          </div>

          <div className="mobile-header-actions">
            <IconButton
              className="mobile-header-icon"
              onClick={handleSearchOpen}
              size="large"
            >
              <SearchIcon />
            </IconButton>

            <IconButton
              className="mobile-header-icon mobile-menu-icon"
              onClick={onMenuClick}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </div>
        </div>
      </header>

      {/* Search Overlay */}
      <Drawer
        anchor="top"
        open={searchOpen}
        onClose={handleSearchClose}
        PaperProps={{
          className: "mobile-search-overlay",
        }}
      >
        <Box className="mobile-search-container">
          <form onSubmit={handleSearch} className="mobile-search-form">
            <input
              type="text"
              placeholder="Search for candidates..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="mobile-search-input"
              autoFocus
            />
            <IconButton
              type="submit"
              className="mobile-search-submit"
              disabled={!searchQuery.trim()}
            >
              <SearchIcon />
            </IconButton>
            <IconButton
              onClick={handleSearchClose}
              className="mobile-search-close"
            >
              <CloseIcon />
            </IconButton>
          </form>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileHeader;
